import React from "react";
import styles from "./Cards.module.css";
import { BiTimeFive } from "react-icons/bi";

const Cards = ({ title, time }) => {
  return (
    <div className={styles.card}>
      <div>
        <BiTimeFive size={100} className={styles.timer_logo} color="#57788e" />
      </div>
      <div className={styles.cardContent}>
        <h3 className={styles.cardTitle}>{title}</h3>
        <p className={styles.cardDescription}>{time}'sec</p>
      </div>
    </div>
  );
};

export default Cards;
